module.exports = __webpack_public_path__ + "static/img/Cancel_an_Appointment_for_a_Patient.c39582d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Cancel_an_Appointment_for_a_Patient.jpg
// module id = Hneq
// module chunks = 7